import { defineComponent, inject, PropType, ref } from 'vue';
import SButton from '@/components/stemdo-components/s-button/SButton.vue';
import SModalCentered from '@/components/stemdo-components/s-modal-centered/SModalCentered.vue';
import { ButtonGroupModals } from '../../../buttonsGroup';

export default defineComponent({
  props: {
    onOpenModal: {
      type: Function,
      required: true,
    },
  },
  components: {
    SButton,
    SModalCentered,
  },
  setup(props) {
    const openAcceptTeamRequestModal = () => {
      props.onOpenModal(ButtonGroupModals.ACCEPT_TR);
    };

    return {
      openAcceptTeamRequestModal,
    };
  },
});
